module.exports = __webpack_public_path__ + "img/fed9b79.png";